import request from '../index'

/**
 * 溯源相关API
 */
const traceApi = {
  /**
   * 获取溯源列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @returns {Promise}
   */
  getTraceList(params) {
    return request({
      url: '/biz/trace',
      method: 'get',
      params
    })
  },
  
  /**
   * 获取加工生产记录列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {number} params.traceId - 溯源ID（可选）
   * @returns {Promise}
   */
  getProcessRecords(params) {
    return request({
      url: '/biz/trace/process',
      method: 'get',
      params
    })
  },
  
  /**
   * 获取溯源码列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {string} params.batch - 生产批次（可选）
   * @returns {Promise}
   */
  getCodeList(params) {
    return request({
      url: '/biz/code',
      method: 'get',
      params
    })
  },
  
  /**
   * 获取溯源码加工生产记录列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {number} params.codeId - 溯源码ID（可选）
   * @returns {Promise}
   */
  getCodeProcessRecords(params) {
    return request({
      url: '/biz/code/process',
      method: 'get',
      params
    })
  }
}

export default traceApi